module.exports = __webpack_public_path__ + "static/Zimbra_logo-d75742fa0aa3993313d0418315a1420f.png";